window.dataLayer = window.dataLayer || [];

// *******************************************
// Version
const appVersion = 1.06;
const appVersionAlert = $('#version');

// Version in the footer
if (appVersionAlert.length > 0) {
  appVersionAlert.html(''
    + 'Version ' + appVersion
    + '<br><small id="device">' + platform.description + '</small>'
  );
}

// *******************************************
// Feedback

// Fill device field
$('#feedbackform-device').val(platform.description);

// Feedback faces effects
$('.btn-face').on('click', function(e){
  $('.btn-face').removeClass('selected');
  $(this).addClass('selected');
  $('#feedbackform-rating').val($(this).data('rating'));
});

// Feedback modal
$('#feedback-form').on('beforeSubmit', function (e) {
  e.preventDefault();
  $.ajax({
    type: 'post',
    data: {
      message: $('#feedbackform-message').val(),
      rating: $('#feedbackform-rating').val(),
      device: $('#feedbackform-device').val(),
    },
    dataType: 'json',
    url: '/' + PointOfSaleSlug + '/user/feedback',
    success: function (data) {
      $('#feedback-success').show();
      $('#feedback-form button').hide();
      setTimeout(function() {
        $('.modal', this).hide();
        $('.modal', this).css('display', 'none');
        $('#feedback').css('display', 'none');
        }, 3000);
    },
    error: function () {
      console.error('Feedback submit error');
    }
  });
}).on('submit', function(e){
  console.log('Feedback form submit');
  e.preventDefault();
});

// *******************************************
// Pjax
let clicked_btnbookingdefinitivelink = null;
let clicked_link = null;
let activeform = false;

// States on pjax and form
$('[data-pjax-container], form')
  // Pjax start and Form submit
  .on('pjax:start submit', function (event) {
    console.log('pjax:start & form submit');

    $('button[type=submit], a[data-pjax="1"]').each(function (e) {
      $(this).addClass('disabled');
      $(this).prop('disabled', true);
    });
    if (clicked_link) {
      clicked_link.html('<i class="fas fa-circle-notch fa-spin"></i>');
      clicked_link.addClass('button-loading');
    }
    $(this).addClass('loading');
  })
  // Pjax end and Form after validate
  .on('pjax:end afterValidate', function (event) {
    console.log('pjax:end & form afterValidate');
    $(this).removeClass('loading');
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();

    $('.button-loading, a[data-pjax=1]').each(function (e) {
      $(this).removeClass('button-loading');
      $(this).removeClass('disabled');
      $(this).prop('disabled', false);
      $(this).html($(this).data('original-text'));
    });
    if (activeform === false) {
      clicked_link = null;
    }
    if (clicked_btnbookingdefinitivelink === true) {
      console.log('clicked_btnbookinglink true');
      if($('#lesson-booking-result').length > 0 && $('#lesson-booking-result').data('lesson-booking-result') == '1'){
        console.log('#lesson-booking-result exists and is success');
        confetti({
          colors: ['#00abdb', '#0faec9', '#21b1b3', '#32b49e', '#41b78d', '#52ba78', '#63bd63', '#73c050', '#84C43C',]
        });
      }
      else{
        console.log('#lesson-booking-result doesnt exists or is not success');
      }

    }
    clicked_btnbookingdefinitivelink = false;
  });

// Pjax links clicks
$('[data-pjax-container]').on('pjax:complete', function (event) {
  console.log('pjax:complete');
  $(this).removeClass('loading');
  lessonsTableBehavious();
}).on('pjax:timeout', function (event) {
  console.log('pjax:timeout');
  event.preventDefault()
}).on('pjax:popstate', function (event) {
  console.log('pjax:popstate');
}).on('click', 'a[data-pjax=1]', function (e) {
  clicked_link = $(this);
});

// *******************************************
// Modal
var lessonsTableBehavious = function(e){

  // Submit buttons clicks
  $('button[type=submit]').on('click', function (e) {
    activeform = true;
    clicked_link = $(this);
  });

  // Select search date on change
  $('#lesson-search-form select').on('change', function (e) {
    $('label[for=lessonsearch-date_selected] i').addClass('d-sm-none').removeClass('d-none');
    $('#lesson-search-form button[type=submit]').trigger('click');

  });


  // Buttons lesson booking
  $('.btn-lesson-booking-definitive').on('click', function (e) {
    console.log('.btn-lesson-booking-definitive click');
    clicked_btnbookingdefinitivelink = true;
  });

}
lessonsTableBehavious();




// Nav links clicks
$('.nav-link:not([href$="\\#"]), .btn-loading').on('click', function (e) {
  clicked_link = $(this);
  clicked_link.css("width", clicked_link.outerWidth());
  if (clicked_link) {
    clicked_link.html('<i class="fas fa-circle-notch fa-spin"></i>');
    clicked_link.addClass('button-loading');
  }
});



// *******************************************
// Modal
$('.close-modal').on('click', function (e) {
  $('.modal').modal('hide');
});

// *******************************************
// Passwords: toggle show
$('.reveal-password').change(function () {
  $($(this).data('target')).attr('type', this.checked ? 'text' : 'password');
});

// *******************************************
// Tooltips
$('[data-toggle="tooltip"]').tooltip();

// *******************************************
// Detect online/offline

var showOnlineContent = function(e){
  $('.online-content').each(function(e){
    $(this).show();
  });
  return true;
}

var hideOnlineContent = function(e){
  $('.online-content').each(function(e){
    $(this).hide();
  });
  return true;
}

if( window.navigator.onLine ){
  console.log('Initially online');
  showOnlineContent();
}
else{
  console.log('Initially offline');
  hideOnlineContent();
}
window.addEventListener('online', () => {console.log('Became online'); showOnlineContent();});
window.addEventListener('offline', () => {console.log('Became offline'); hideOnlineContent();});


// *******************************************
// Service Worker
(function (glob, document) {
  'use strict'

  function registerServiceWorker() {
    navigator.serviceWorker
      .register(FrontendAssetBundlePath + '/sw.js', {scope: '/'})
      .then(function (reg) {
        console.log("serviceworker: registered")
      })
      .catch(function (err) {
        console.log("serviceworker: error when registering", err)
      })
  }

  function init() {
    registerServiceWorker()
  }

  init()

})(window, document)

// *******************************************
// Add to home screen
const installAlert = document.getElementById('install-app-alert');
const installButton = document.getElementById('install-app-button');
const installButtonSuccess = document.getElementById('install-app-button-success');

let deferredPrompt;

if(installAlert){
  console.log('install app alert is present');
  installAlert.style.display = 'none';

  // beforeinstallprompt event only works on Chrome, Edge, Opera (desktop and mobile versions)
  // @see https://caniuse.com/?search=beforeinstallprompt
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('beforeinstallprompt event was fired.');

    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Update UI to notify the user they can add to home screen
    installAlert.style.display = 'block';

    installButton.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button

      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          installButton.style.display = 'none';
          installButtonSuccess.style.display = 'block';
          window.dataLayer.push({
            'event': 'install',
            'eventCategory': 'PWA',
            'eventAction': 'yes',
            'eventLabel': undefined,
            'eventValue': undefined
          });

          console.log('User accepted the A2HS prompt');
        }
        else {
          window.dataLayer.push({
            'event': 'install',
            'eventCategory': 'PWA',
            'eventAction': 'no',
            'eventLabel': undefined,
            'eventValue': undefined
          });
          console.log('User dismissed the A2HS prompt');
        }
        deferredPrompt = null;
      });
    });

  });
}

// *******************************************
// PWA alert close button
$('#install-app-close').on('click', function(e){
  $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/'+ PointOfSaleSlug  +'/user/pwanothanks',
      success: function(data){
        console.log('success');
      },
      error: function(){
        console.log('error');
      }
    });
});


// *******************************************
// Detect when the PWA was successfully installed
window.addEventListener('appinstalled', () => {
  // Hide the app-provided install promotion
  // Clear the deferredPrompt so it can be garbage collected
  deferredPrompt = null;
  // Optionally, send analytics event to indicate successful install
  console.log('PWA was installed');
  appVersionAlert.append('<br>' +'PWA Installed ');
});

// *******************************************
// Detect display mode

function getPWADisplayMode() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  if (document.referrer.startsWith('android-app://')) {
    return 'twa';
  } else if (navigator.standalone || isStandalone) {
    return 'standalone';
  }
  return 'browser';
}


window.dataLayer.push({
  'event': 'displaymode',
  'eventCategory': 'PWA',
  'eventAction': getPWADisplayMode(),
  'eventLabel': undefined,
  'eventValue': undefined
});


// *******************************************
// Detect display mode
$('a[data-tracklink]').on('click', function(e){
  console.log('Track link');
  window.dataLayer.push({
    'event': 'Link',
    'eventCategory': 'External',
    'eventAction': $(this).data('tracklink'),
    'eventLabel': undefined,
    'eventValue': undefined
  });
});